import actions from 'actions'

export default function entities(state = {}, action) {
  const { type, error } = action

  if (type === actions.COMMON_RESET_ERROR_MESSAGE) {
    return null
  } else if (error) {
    return action.error
  }

  return state
}



/** WEBPACK FOOTER **
 ** ./src/reducers/error-message/error-message.js
 **/